import Polyglot from 'node-polyglot';
import phrases from './phrases.json';

const polyglot = new Polyglot({ phrases });

export { polyglot };
export default polyglot.t.bind(polyglot);
